import { defineComponent as _defineComponent } from 'vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import CatalogProductCard from '~/domains/catalog/components/CatalogProductCard.vue';
import { getProductContent } from '~/helpers/vue';

interface Props {
  products?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedProducts',
  props: {
    products: { default: () => [] }
  },
  setup(__props: any) {



const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
  lazy: {
    enabled: true,
    checkInView: true,
    loadPrevNext: true,
    loadPrevNextAmount: 5,
  },
};

return { __sfc: true,swiperOptions, Swiper, SwiperSlide, CatalogProductCard, getProductContent }
}

})